/**
 * 获取本地储存的值
 * @param item 获取某个本地存储的对象值里的字段内容
 * @param storageName 获取某个本地存储的对象/数组值
 * @param isParse 对象不填、数组：'[]'、两者都不是：false
 * @param storage 使用哪个本地存储，localStorage/sessionStorage
 * @returns
 */
export const getStorageInfo = (
  item: string = '',
  storageName: string = 'storageContext',
  isParse: any = '{}',
  storage: Storage = localStorage
) => {
  if (isParse) {
    const storageContextStr = storage.getItem(storageName) || isParse;
    const storageContext = JSON.parse(storageContextStr);
    return item ? storageContext?.[item] : storageContext;
  } else {
    return localStorage.getItem(storageName);
  }
};
